export default __webpack_public_path__ + "static/media/6.5104a5c9.png";